const NOT_CONFIGURED = "not configured";

function readField(source, key) {
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return NOT_CONFIGURED;
  }
  if (!Object.prototype.hasOwnProperty.call(source, key) || source[key] == null) {
    return NOT_CONFIGURED;
  }
  return source[key];
}

function readValue(source) {
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return NOT_CONFIGURED;
  }
  if (!Object.prototype.hasOwnProperty.call(source, "value")) {
    return NOT_CONFIGURED;
  }
  return source.value;
}

export function activationValueText(value) {
  if (Array.isArray(value)) {
    if (value.length === 0) {
      return "[]";
    }
    return value.map((item) => (item === "" ? '""' : String(item))).join(", ");
  }
  if (value === null) {
    return "null";
  }
  if (value === "") {
    return '""';
  }
  return String(value);
}

function stringList(value) {
  if (!Array.isArray(value) || value.some((item) => typeof item !== "string")) {
    return NOT_CONFIGURED;
  }
  return value;
}

function activationList(value) {
  if (!Array.isArray(value)) {
    return { status: NOT_CONFIGURED, clauses: [] };
  }
  return {
    status: null,
    clauses: value.map((item, index) => ({
      index,
      factKey: activationValueText(readField(item, "fact_key")),
      op: activationValueText(readField(item, "op")),
      value: readValue(item),
    })),
  };
}

function questionsView(value) {
  if (!Array.isArray(value)) {
    return { status: NOT_CONFIGURED, questions: [] };
  }
  return {
    status: null,
    questions: value.map((item, index) => {
      const activation = activationList(item && item.activation);
      const enabled = readField(item, "enabled");
      const mandatory = readField(item, "mandatory");
      return {
        index,
        key: activationValueText(readField(item, "key")),
        enabled: enabled === "" ? '""' : enabled,
        mandatory: mandatory === "" ? '""' : mandatory,
        dependsOn: stringList(item && item.depends_on),
        activationStatus: activation.status,
        activation: activation.clauses,
      };
    }),
  };
}

function stringListStatus(value) {
  if (!Array.isArray(value) || value.some((item) => typeof item !== "string")) {
    return { status: NOT_CONFIGURED, items: [] };
  }
  return { status: null, items: value };
}

function messageMap(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return { status: NOT_CONFIGURED, messages: [] };
  }
  return {
    status: null,
    messages: Object.keys(value).map((key) => ({
      key,
      value: typeof value[key] === "string" ? value[key] : NOT_CONFIGURED,
    })),
  };
}

function rulesView(value) {
  if (!Array.isArray(value)) {
    return { status: NOT_CONFIGURED, rules: [] };
  }
  return {
    status: null,
    rules: value.map((item, index) => {
      const enabled = readField(item, "enabled");
      return {
        index,
        ruleId: activationValueText(readField(item, "rule_id")),
        enabled: enabled === "" ? '""' : enabled,
        requiresKeys: stringList(item && item.requires_keys),
      };
    }),
  };
}

export function roofingV2QualificationView(settings) {
  const qualification = settings && settings.qualification;
  const questions = questionsView(qualification && qualification.questions);
  const rules = rulesView(qualification && qualification.dq_rules);
  const blocked = stringListStatus(settings && settings.blocked_property_types);
  const messages = messageMap(settings && settings.rejection_messages);
  const strictQualificationGate = readField(settings, "strict_qualification_gate");
  const minBudget = readField(settings, "min_budget");
  const maxStoreys = readField(settings, "max_storeys");
  return {
    strictQualificationGate: strictQualificationGate === "" ? '""' : strictQualificationGate,
    questionsStatus: questions.status,
    questions: questions.questions,
    rulesStatus: rules.status,
    rules: rules.rules,
    minBudget: minBudget === "" ? '""' : minBudget,
    maxStoreys: maxStoreys === "" ? '""' : maxStoreys,
    blockedPropertyTypesStatus: blocked.status,
    blockedPropertyTypes: blocked.items,
    tenantPolicy: activationValueText(readField(settings, "tenant_policy")),
    asbestosPolicy: activationValueText(readField(settings, "asbestos_policy")),
    unqualifiedAction: activationValueText(readField(settings, "unqualified_action")),
    rejectionMessagesStatus: messages.status,
    rejectionMessages: messages.messages,
  };
}
